module.exports = __webpack_public_path__ + "static/media/site.108b826a.webmanifest";